import * as React from "react";
const SvgFiRrSkewer = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-skewer_svg__a)">
      <path
        fill="#062147"
        d="M23.7.293a1 1 0 0 0-1.414 0L19.5 3.086l-1.8-1.793a1 1 0 0 0-1.413 1.414L18.084 4.5 16.5 6.086l-1.794-1.793a1 1 0 0 0-1.413 1.414L15.085 7.5l-1.212 1.213c-3.54-4.385-6.308.58-4.07 4.07l-1.289 1.29-1.792-1.806A1 1 0 1 0 5.3 13.675l1.8 1.812c-1.016.982-1.235 1.563-3.24 1.538a3.5 3.5 0 1 0 2.116 5.949 1 1 0 0 0-1.413-1.414 1.506 1.506 0 0 1-2.376-1.79c.108-.183.44-.745 1.672-.745 2.5.024 3.333-.753 4.65-2.118l1.782 1.8a.999.999 0 0 0 1.652-1.082 1 1 0 0 0-.233-.325l-1.788-1.8 1.287-1.288c3.517 2.236 8.453-.544 4.078-4.078l1.213-1.22 1.792 1.793A1 1 0 0 0 19.7 9.293L17.912 7.5 19.5 5.914l1.79 1.793a1 1 0 0 0 1.41-1.414L20.911 4.5l2.79-2.793a1 1 0 0 0 0-1.414m-8.714 12.483a2.893 2.893 0 0 1-3.762-3.764.13.13 0 0 1 .144.023l3.6 3.6a.13.13 0 0 1 .018.14"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-skewer_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrSkewer;
